import React from "react";

const CategoryTable = ({
  currentCategories,
  categoriesLength,
  totalPages,
  currentPage,
  handlePageChange,
  toggleDropdown,
  toggleModal,
  openDropdownId,
  handleEditModalOpen,
  handlePreviewModalOpen,
  handleDeleteModalOpen,
}) => {
  return (
    <section className="flex-grow bg-gray-50 dark:bg-gray-900 p-3 sm:p-5 antialiased">
      <div className="mx-auto max-w-screen-xl px-4 lg:px-12">
        <div className="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 p-4">
            <div className="w-full md:w-1/2">
              <form className="flex items-center">
                <label htmlFor="simple-search" className="sr-only">
                  Search
                </label>
                <div className="relative w-full">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <i className="fa fa-search text-gray-500 dark:text-gray-400"></i>
                  </div>
                  <input
                    type="text"
                    id="simple-search"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Search"
                    required=""
                  />
                </div>
              </form>
            </div>
            <div className="flex flex-col md:flex-row items-center w-full md:w-auto justify-end space-y-2 md:space-y-0 md:space-x-3">
              <button
                type="button"
                className="flex items-center justify-center text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
                onClick={toggleModal}
              >
                <i className="fa fa-plus h-3.5 w-3.5 mr-2"></i>
                Add Category
              </button>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">Category ID</th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">Category Name</th>
                  <th className="px-4 py-2 text-left text-sm font-medium text-gray-500">Description</th>
                  <th className="px-6 py-2 text-left text-sm font-medium text-gray-500">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentCategories.map((category) => (
                  <tr key={category.category_id} className="border-b dark:border-gray-700">
                    <td className="px-4 py-3">{category.category_id}</td>
                    <td className="px-4 py-3">{category.name}</td>
                    <td className="px-4 py-3">{category.description}</td>
                    <td className="px-6 py-12 flex items-center justify-center relative">
                      <button
                        id={`dropdown-button-${category.category_id}`}
                        className="inline-flex items-center justify-center text-sm font-medium hover:bg-gray-100 dark:hover:bg-gray-700 p-1.5 dark:hover:bg-gray-800 text-center text-gray-500 hover:text-gray-800 rounded-lg focus:outline-none dark:text-gray-400 dark:hover:text-gray-100"
                        type="button"
                        onClick={() => toggleDropdown(category.category_id)}
                      >
                        <i className="fa fa-ellipsis-h text-lg"></i>
                      </button>
                      <div
                        id={`dropdown-${category.category_id}`}
                        className={`${
                          openDropdownId === category.category_id ? "block" : "hidden"
                        } absolute left-0 top-20 w-25 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 z-50`}
                      >
                        <ul className="py-1 text-sm" aria-labelledby={`dropdown-button-${category.category_id}`}>
                          <li>
                            <button
                              type="button"
                              className="flex items-center w-full py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg focus:outline-none"
                              onClick={() => handleEditModalOpen(category)}
                            >
                              <i className="fas fa-edit w-4 h-4 mr-2"></i>
                              Edit
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="flex items-center w-full py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg focus:outline-none"
                              onClick={() => handlePreviewModalOpen(category)}
                            >
                              <i className="fas fa-eye w-4 h-4 mr-2"></i>
                              Preview
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className="flex items-center w-full py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-700 text-red-500 dark:hover:text-red-400 rounded-lg focus:outline-none"
                              onClick={() => handleDeleteModalOpen(category)}
                            >
                              <i className="fas fa-trash w-4 h-4 mr-2"></i>
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="p-4 flex justify-between items-center border-t dark:border-gray-700">
              <span className="text-sm text-gray-500 dark:text-gray-400">
                Showing {categoriesLength ? 1 : 0} to {Math.min(categoriesLength, currentCategories.length)} of {categoriesLength} Entries
              </span>
              <div className="flex space-x-2">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                  <button
                    key={pageNumber}
                    className={`px-3 py-1 rounded-lg ${
                      currentPage === pageNumber
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-600"
                    }`}
                    onClick={() => handlePageChange(pageNumber)}
                  >
                    {pageNumber}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryTable;
